import React from 'react'
import { Dropdown } from 'react-bootstrap'

/**
 * Unified 3-dots actions menu for tables.
 * Uses fixed Popper strategy so the menu stays above rows / table-responsive overflow.
 *
 * Класс table-dropdown-fixed — маркер для стилей: такому меню не нужен костыль
 * `overflow: visible` на .table-responsive (он сбрасывает горизонтальный скролл
 * таблицы и отключает залипающие колонки), меню и так не обрезается.
 */
function TableDropdown({ id, children, align = 'end', toggleClassName }) {
	return (
		<div className="table-dropdown table-dropdown-fixed">
			<Dropdown id={id} align={align}>
				<Dropdown.Toggle variant="outline-primary" className={toggleClassName}>
					<i className="uil uil-ellipsis-v"></i>
				</Dropdown.Toggle>
				<Dropdown.Menu
					renderOnMount
					popperConfig={{ strategy: 'fixed' }}>
					{children}
				</Dropdown.Menu>
			</Dropdown>
		</div>
	)
}

export default TableDropdown
